// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-404 {
  text-align: center;
  margin-top: 100px;
}
.page-404 .page-404--message > h1, .page-404 h3 {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/common/Page404.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,iBAAA;AACF;AACE;EACE,WAAA;AACJ","sourcesContent":[".page-404 {\n  text-align: center;\n  margin-top: 100px;\n\n  .page-404--message > h1, h3 {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
